import React from "react";
import Div from "../../widget/common/ui/Div";
import { navigate } from "../../service/navigation/Navigation";
import { ButtonSingle } from "../../widget/common/form/Button";
import AppTranslation from "../../service/app_translation/AppTranslation";
import { appRoutes } from "../../routes/routes";

const NotFoundScreen = () => {
  return (
    <Div className="vh-100- dvh-100 d-center">
      <div>
        <Div className="font-size-20_21 text-center pb-5">Not Found</Div>
        {/* <ButtonSingle handleClick={() => navigate(-1)}> go back</ButtonSingle> */}
        <ButtonSingle handleClick={() => navigate(appRoutes.routeNameSplash)}>
          {AppTranslation.text("home")}
        </ButtonSingle>
      </div>
    </Div>
  );
};

export default NotFoundScreen;
export const routeName: string = "/not-found";
